// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Core from "@lingui/core";
import * as Json_Encode$JsonCombinators from "@glennsl/rescript-json-combinators/src/Json_Encode.re.mjs";

let empty = Json_Encode$JsonCombinators.object([]);

let Messages = {
  empty: empty
};

let i18n = Core.i18n;

let detectedI18n = Core.setupI18n();

let I18nProvider = {};

function loadMessages(src) {
  return lang => {
    let tmp;
    switch (lang) {
      case "ja" :
        tmp = src.ja;
        break;
      default:
        tmp = src.en;
    }
    return [tmp.then(messages => {
        React.startTransition(() => i18n.load(lang, messages.messages));
      })];
  };
}

function loadMessagesForDetected(src) {
  return lang => {
    let tmp;
    switch (lang) {
      case "ja" :
        tmp = src.ja;
        break;
      default:
        tmp = src.en;
    }
    return [tmp.then(messages => {
        React.startTransition(() => detectedI18n.load(lang, messages.messages));
      })];
  };
}

let Util = {};

let UtilString = {};

export {
  Messages,
  i18n,
  detectedI18n,
  I18nProvider,
  loadMessages,
  loadMessagesForDetected,
  Util,
  UtilString,
}
/* empty Not a pure module */
